export function getAge(dateString) {
    let today = new Date();
    let birthDate = new Date(dateString);

    let age = today.getFullYear() - birthDate.getFullYear();
    let m = today.getMonth() - birthDate.getMonth();
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
 }

export function validateFields(arr, conditions = {}) {
    let errors = false;
    const cyrillicAndNums = /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()\d]+$/;
    const cyrillic = /^[\u0400-\u04FF\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/;
    const latin = /^[A-z\u00C0-\u00ff\s'\.,-\/#!$%\^&\*;:{}=\-_`~()]+$/;
    const email = /^[a-zA-Z0-9._-]+@[a-zA-Z_-]+?\.[a-zA-Z]{2,3}$/;

    if (!conditions.ageMin) conditions.ageMin = 18
    if (!conditions.ageMax) conditions.ageMax = 65

    arr.forEach((obj, index) => {
      obj.error = ''

      // Фамилия
      if (obj.validation === 'last_name') {
        if (!obj.value) {
          obj.error = 'укажите фамилию';
        } else if (!cyrillic.test(obj.value)) {
          obj.error = 'допустимы только символы кириллицы';
        }
      }
  
      // Имя
      if (obj.validation === 'first_name') {
        if (!obj.value) {
          obj.error = 'укажите имя';
        } else if (!cyrillic.test(obj.value)) {
          obj.error = 'допустимы только символы кириллицы';
        }
      }
  
      // Отчество
      if (obj.validation === 'middle_name') {
        if (obj.value && !cyrillic.test(obj.value)) {
          obj.error = 'допустимы только символы кириллицы';
        }
      }
  
      // Дата рождения
      if (obj.validation === 'birth_date') {
        if (!obj.value) {
          obj.error = 'укажите корректную дату рождения';
        } else if (getAge(obj.value) < conditions.ageMin) {
          obj.error = `минимальный возраст ${conditions.ageMin} ${conditions.ageMin < 5 ? 'года' : 'лет'}`;
        } else if (getAge(obj.value) > conditions.ageMax) {
          obj.error = `максимальный возраст ${conditions.ageMax} лет включительно`;
        }
      }

      // Место рождения
      if (obj.validation === 'birth_place') {
        if (!obj.value) {
          obj.error = 'укажите место рождения';
        }
      }
  
      // Телефон
      if (obj.validation === 'phone') {
        if (!obj.value) {
          obj.error = 'укажите номер телефона';
        } else if (obj.value && obj.value.length < 18) {
          obj.error = 'укажите номер телефона полностью';
        }
      }
  
      // Электронная почта
      if (obj.validation === 'email') {
        if (!obj.value) {
          obj.error = 'укажите адрес электронной почты';
        } else if (obj.value && !email.test(obj.value)) {
          obj.error = 'укажите корректный адрес электронной почты';
        }
      }

      // Пол
      if (obj.validation === 'sex') {
        if (!obj.value) {
          obj.error = 'укажите пол';
        }
      }

      // Паспорт серия
      if (obj.validation === 'passport_serial') {
        if (!obj.value) {
          obj.error = 'укажите серию паспорта';
        } else if (obj.value.length < 4) {
          obj.error = 'укажите серию паспорта (4 цифры)';
        }
      }

      // Паспорт номер
      if (obj.validation === 'passport_number') {
        if (!obj.value) {
          obj.error = 'укажите номер паспорта';
        } else if (obj.value.length < 6) {
          obj.error = 'укажите номер паспорта (6 цифр)';
        }
      }

      // Паспорт код подразделения
      if (obj.validation === 'passport_code') {
        if (!obj.value) {
          obj.error = 'укажите код подразделения';
        } else if (obj.value.length < 7) {
          obj.error = 'укажите код подразделения (6 цифр)';
        }
      }

      // Паспорт дата выдачи
      
      if (obj.validation === 'passport_date') {
        if (!obj.value) {
          obj.error = 'укажите дату выдачи';
        } else if (getAge(conditions.birthDate) >= 45 && new Date(obj.value).getTime() - new Date(conditions.birthDate).getTime() < Math.max(new Date('October 01, 1997').getTime() - new Date(conditions.birthDate).getTime(), 1420150000000)) {
          obj.error = 'укажите корректную дату выдачи (с 45 лет)';
        } else if (getAge(conditions.birthDate) >= 20 && new Date(obj.value).getTime() - new Date(conditions.birthDate).getTime() < 631150000000) {
          obj.error = 'укажите корректную дату выдачи (с 20 лет)';
        } else if (new Date(obj.value).getTime() - new Date(conditions.birthDate).getTime() < 441800000000) {
          obj.error = 'укажите корректную дату выдачи (с 14 лет)';
        } else if (new Date(obj.value).getTime() > new Date(new Date()).getTime()) {
          obj.error = 'Дата выдачи не может быть будущей';
        }
      }

      // Паспорт кем выдан
      if (obj.validation === 'passport_given') {
        if (!obj.value) {
          obj.error = 'укажите подразделение';
        } else if (!cyrillicAndNums.test(obj.value)) {
          obj.error = 'допустимы только символы кириллицы';
        }
      }

      // Адрес
      if (obj.validation === 'address') {
        if (!obj.value) {
          obj.error = 'укажите адрес регистрации';
        }
      }

      // Город
      if (obj.validation === 'city') {
        if (!obj.value) {
          obj.error = 'укажите город';
        } else if (obj.hasOwnProperty('key') && ['', null].includes(obj.key)) {
          obj.error = 'укажите город из списка'
        }
      }

      // Улица
      if (obj.validation === 'street') {
        if (!obj.value) {
          obj.error = 'укажите улицу';
        } else if (obj.hasOwnProperty('key') && ['', null].includes(obj.key)) {
          obj.error = 'укажите улицу из списка'
        }
      }

      // Дом
      if (obj.validation === 'house') {
        if (!obj.value) {
          obj.error = 'укажите дом';
        }
      }

      // --------------------------------------- прочие валидаторы
      
      // Сумма взноса
      if (obj.validation === 'payment') {
        if (!obj.value) {
          obj.error = 'укажите сумму взноса';
        } else if (conditions.minPayment && +obj.value < conditions.minPayment) {
          obj.error = 'минимальная сумма взноса ' + conditions.minPayment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' рублей';
        } else if (conditions.maxPayment && +obj.value > conditions.maxPayment) {
          obj.error = 'максимальная сумма взноса ' + conditions.maxPayment.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' рублей';
        }
      }

      // Родственные отношения
      if (obj.validation === 'relationship') {
        if (obj.value && !cyrillic.test(obj.value)) {
          obj.error = 'допустимы только символы кириллицы';
        }
      }

      // Доля
      if (obj.validation === 'procent') {
        if (!obj.value) {
          obj.error = 'укажите долю от страховой суммы';
        }
      }
  
      if (obj.error) {
        errors = true
      }
    });
    return errors
  }